import { Component, OnInit, Input, Output, EventEmitter, OnChanges, Injector, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsInquiryPromotionInfoService } from '../../../adapters/bsInquiryPromotionInfo.service';
import { BsInquiryRecommendProductService } from '../../../adapters/bsInquiryRecommendProduct.service';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { BaseComponents } from '../../../base.component';
import { getStorage, setStorage } from 'src/app/core/utilities';

@Component({
    selector: 'app-tisco-intro-slide',
    templateUrl: './tisco-intro-slide.component.html',
    styleUrls: ['./tisco-intro-slide.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TiscoIntroSlideComponent extends BaseComponents implements OnInit, OnChanges {

  products: any = [];
  dataSet: string;
  slide: boolean = false;
  _slideData: any
  @Input()
  get slideData() {
    return this._slideData;
  }
  set slideData(v) {
    this._slideData = v;
    this.slideDataChange.emit(v);
  }
  @Output() slideDataChange = new EventEmitter()

  constructor(
    protected injectorObj:Injector,
    private sanitizer: DomSanitizer,
    private bsInquiryRecommendProductService: BsInquiryRecommendProductService,
    private bsInquiryPromotionInfoService: BsInquiryPromotionInfoService,
    private router: Router,
    //private logger: NGXLogger
  ) { 
    super(injectorObj);
  }

  ngOnInit() {
    // this.initPage()
  }

  ngOnChanges(): void {
    this.initPage()
  }

  initPage() {
    this.products = []
    if (this._slideData && this._slideData.slideType === 'recommend' && this._slideData.securityGroupID) {
      this.slide = true;
      this.dataSet = '1_1938';
      let body = { "appCode": environment.appCode, "securityGroupID": this._slideData.securityGroupID };
      let mockupData = getStorage('slideRecommend' + environment.appCode + '-' + this._slideData.securityGroupID)
      if (mockupData) {
        setTimeout(() => {
          this.products = mockupData
        }, 10);
      }
      this.bsInquiryRecommendProductService.exec(body).then((res: any) => {
        if (res.response_code == "40000") {
          setStorage('slideRecommend' + environment.appCode + '-' + this._slideData.securityGroupID, res.data);
          for (let c of res.data) {
            if (c.web_url) {
              const blog_url = new URL(c.web_url);
              c.pathname = blog_url.pathname + blog_url.search;
            }
          }
          this.products = res.data;
          console.log('rec product');
          console.log(this.products);
        }
      })
    } else if (this._slideData && this._slideData.slideType === 'promotion') {
      this.slide = false;
      this.dataSet = '1_2034';
      let body = { "appCode": environment.appCode };
      let mockupData = getStorage('slidePromotion' + environment.appCode)
      if (mockupData) {
        setTimeout(() => {
          this.products = mockupData
        }, 10);
      }
      this.bsInquiryPromotionInfoService.exec(body).then((res: any) => {
        if (res.response_code == "40000") {
          setStorage('slidePromotion' + environment.appCode, res.data)
          for (let c of res.data) {
            if (c.web_url) {
              const blog_url = new URL(c.web_url);
              c.pathname = blog_url.pathname + blog_url.search;
            }
          }
          this.products = res.data;
          //this.logger.debug(this.products)
          console.log('this.products2');
          console.log(this.products);
        }
      })
    }

  }

  goUrl(url) {
    const original = window.location.origin;
    if (url.includes(original)) {
      url = url.replace(original, "");
      this.router.navigate([url]);
    } else {
      window.open(url);
    }
  }
  openUrl(product) {
    if (product.online_sale_or_insure_interested_button_flag) {
      if (product.url1) {
        this.goUrl(product.url1);
        return;
      }
    }
    const short_link = (product.pathname ? '/' + product.pathname : '');
    if (product.onlineSale && (product.url1 == null || product.url1 == '')) {
      product.linkTarget = '_self'
      product.linkUrl = '/buy-insurance' + short_link;
    } else if (product.onlineSale && product.url1 !== null && product.url1 !== '') {
      product.linkTarget = '_blank'
      product.linkUrl = product.url1
    } else {
      product.linkTarget = '_self'
      product.linkUrl = '/form' + short_link
    }
    let params: any = {
      'securityGroupID': product.securityGroupID,
      'securityTypeID': product.securityTypeID,
      'securitySubTypeID': product.securitySubTypeID,
      'securityID': product.securityID
    }

    if (product.pathname) {
      params = {}
    }
    if (product.linkTarget == '_self') {
      this.router.navigate([product.linkUrl], { queryParams: params });
    } else {
      window.open(product.linkUrl)
    }
  }




}
